class InfoLibrary
    constructor: (el) ->
        @.$el = el
        @.$loadMoreButton = @.$el.querySelector '.info-library__load-more-button'
        @.$resultsEl = @.$el.querySelector '.info-library__results'
        @.$resultsCountEl = @.$el.querySelector '.info-library__results-count'
        @.$resultsCountTextEl = @.$el.querySelector '.info-library__results-text'
        @.$resultsCounterEl = @.$el.querySelector '.info-library__results-counter'
        @.$searchbarInputEl = @.$el.querySelector '.info-library__searchbar .input__field'
        @.$sortSelect = @.$el.querySelector '.info-library__sort select'
        @.$toggleFiltersButton = @.$el.querySelector '.info-library__toggle-filters'
        @.$toggleFiltersButtonMobile = @.$el.querySelector '.info-library__toggle-filters-button-mobile'

        @.amount = if @.$el.dataset?.amount then parseInt(@.$el.dataset.amount, 10) else 6
        @.api = @.$el.dataset?.api ? false
        @.apiMediatypes = if @.$el.dataset?.mediatypes then (if @.$el.dataset.mediatypes != '' then @.$el.dataset.mediatypes.split(',') else []) else []
        @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
        @.filters = []
        @.filterResetText = @.$el.dataset?.filterReset ? 'Filter zurücksetzen'
        @.loaded = false
        @.results = []
        @.resultsLoadedAtOnce = @.$el.classList.contains 'info-library--rlao'
        @.resultsText = @.$resultsCounterEl?.dataset?.text ? 'Ergebnis'
        @.resultsPluralText = @.$resultsCounterEl?.dataset?.pluralText ? 'Ergebnisse'
        @.shownElements = 0
        @.sortBy = if @.$sortSelect then @.$sortSelect.value.split(',') else []
        @.totalResults = 0

        @.$el.classList.add 'info-library--bound'

        @.InitEvents()
        if @.api
            @.GetData()
        else
            @.AppendResults()
        
        return

    AddToFilters: (filterKey, filterValue) ->
        self = @
        if @.filters.map((e) -> return e.filterKey).indexOf(filterKey) > -1
            @.RemoveFromFilters filterKey
        @.filters.push { filterKey: filterKey, filterValue: filterValue }
        return

    AppendResults: ->
        if @.results.length > 0
            count = 1
            resultsStart = @.shownElements
            @.SortResults @.sortBy
            for index in [resultsStart..@.results.length - 1]
                result = @.results[index]
                result.year = @.GetResultYear result
                result.filterMatch = []
                result.attrs = {
                    class: ['info-library__card']
                }
                infoCardEl = window.CreateInfoCard result
                if count <= @.amount
                    infoCardEl.classList.add 'info-library__card--shown'
                @.$resultsEl.appendChild infoCardEl
                result.el = infoCardEl
                count++
            window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }
        else
            @.$el.classList.add 'info-library--none-results'
        if @.shownElements == 0
            @.CreateFilter()
            @.SetLoaded()
        else
            @.ReCreateFilters()
        @.shownElements = @.results.length
        @.$resultsCountEl.textContent = @.results.length
        if @.results.length == 1
            @.$resultsCountTextEl.textContent = @.resultsText
        else
            @.$resultsCountTextEl.textContent = @.resultsPluralText
        @.$loadMoreButton.disabled = @.results.length >= @.totalResults
        return
    
    CreateFilter: ->
        self = @
        mediaTypes = []
        targetGroups = []
        topics = []
        years = []
        for result in @.results
            if result.mediaType
                if mediaTypes.indexOf(result.mediaType) < 0
                    mediaTypes.push result.mediaType
            if result.targetGroup
                if targetGroups.indexOf(result.targetGroup) < 0
                    targetGroups.push result.targetGroup
            if result.topic
                if topics.indexOf(result.topic) < 0
                    topics.push result.topic
            if result.year
                if years.indexOf(result.year) < 0
                    years.push result.year

        mediaTypes.sort (a,b) ->
            return if a >= b then 1 else -1
        mediaTypeOptions = []
        mediaTypes.forEach (mediaType) ->
            mediaTypeOptions.push {
                text: mediaType
                value: mediaType
            }
            return
        mediaTypeOptions.push {
            text: @.filterResetText
            value: 'filter-reset'
        }
        mediaTypeSelect = window.CreateSelect {
            attrs: {
                class: ['info-library__media-sort']
            },
            menuOver: true
            noOutline: true
            options: mediaTypeOptions
            placeholder: 'Medienart'
        }
        @.$el.querySelector '.info-library__media-sort-row'
            .appendChild mediaTypeSelect
        mediaTypeSelect.querySelector('select').addEventListener 'change', (e) ->
            if e.target.value == 'filter-reset'
                self.RemoveFromFilters 'mediaType'
                self.FilterResults()
                e.target.closest('.select').dispatchEvent new CustomEvent 'select-reset', { bubbles: false }
            else
                self.AddToFilters 'mediaType', e.target.value
                self.FilterResults()
            return

        targetGroups.sort (a,b) ->
            return if a >= b then 1 else -1
        targetGroupOptions = []
        targetGroups.forEach (targetGroup) ->
            targetGroupOptions.push {
                text: targetGroup
                value: targetGroup
            }
            return
        targetGroupOptions.push {
            text: @.filterResetText
            value: 'filter-reset'
        }
        targetGroupSelect = window.CreateSelect {
            attrs: {
                class: ['info-library__target-sort']
            },
            menuOver: true
            noOutline: true
            options: targetGroupOptions
            placeholder: 'Zielgruppe'
        }
        @.$el.querySelector '.info-library__target-sort-row'
            .appendChild targetGroupSelect
        targetGroupSelect.querySelector('select').addEventListener 'change', (e) ->
            if e.target.value == 'filter-reset'
                self.RemoveFromFilters 'targetGroup'
                self.FilterResults()
                e.target.closest('.select').dispatchEvent new CustomEvent 'select-reset', { bubbles: false }
            else
                self.AddToFilters 'targetGroup', e.target.value
                self.FilterResults()
            return

        topics.sort (a,b) ->
            return if a >= b then 1 else -1
        topicOptions = []
        topics.forEach (topic) ->
            topicOptions.push {
                text: topic
                value: topic
            }
            return
        topicOptions.push {
            text: @.filterResetText
            value: 'filter-reset'
        }
        topicSelect = window.CreateSelect {
            attrs: {
                class: ['info-library__topic-sort']
            },
            menuOver: true
            noOutline: true
            options: topicOptions
            placeholder: 'Thema'
        }
        @.$el.querySelector '.info-library__topic-sort-row'
            .appendChild topicSelect
        topicSelect.querySelector('select').addEventListener 'change', (e) ->
            if e.target.value == 'filter-reset'
                self.RemoveFromFilters 'topic'
                self.FilterResults()
                e.target.closest('.select').dispatchEvent new CustomEvent 'select-reset', { bubbles: false }
            else
                self.AddToFilters 'topic', e.target.value
                self.FilterResults()
            return

        years.sort (a,b) ->
            return if a >= b then 1 else -1
        yearOptions = []
        years.forEach (year) ->
            yearOptions.push {
                text: year
                value: year
            }
            return
        yearOptions.push {
            text: @.filterResetText
            value: 'filter-reset'
        }
        yearSelect = window.CreateSelect {
            attrs: {
                class: ['info-library__year-sort']
            },
            menuOver: true
            noOutline: true
            options: yearOptions
            placeholder: 'Erscheinungsjahr'
        }
        @.$el.querySelector '.info-library__year-sort-row'
            .appendChild yearSelect
        yearSelect.querySelector('select').addEventListener 'change', (e) ->
            if e.target.value == 'filter-reset'
                self.RemoveFromFilters 'year'
                self.FilterResults()
                e.target.closest('.select').dispatchEvent new CustomEvent 'select-reset', { bubbles: false }
            else
                self.AddToFilters 'year', e.target.value
                self.FilterResults()
            return
        
        window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }

        if window.innerWidth <= 768
            @.$el.classList.add 'info-library--filters-hidden'

        return

    FilterResults: ->
        self = @
        if @.filters.length < 1
            @.$el.classList.remove 'info-library--filter-active'
            @.FilterResultsReset()
        else
            @.$el.classList.add 'info-library--filter-active'
            @.results.forEach (result) ->
                result.el.classList.remove 'info-library__card--matching-filter'
                result.filterMatch = []
                self.filters.forEach (filter) ->
                    if filter.filterKey == 'tag'
                        if result.tags
                            if result.tags.length > 0
                                tagMatch = false
                                result.tags.forEach (tag) ->
                                    if tag.text.toLowerCase().indexOf(filter.filterValue.toLowerCase()) >= 0
                                        tagMatch = true
                                    return
                                if tagMatch
                                    result.filterMatch.push 1
                                else
                                    result.filterMatch.push 0
                            else
                                result.filterMatch.push 0
                        else
                            result.filterMatch.push 0
                    else
                        if result[filter.filterKey]
                            if result[filter.filterKey].toString() == filter.filterValue.toString()
                                result.filterMatch.push 1
                            else
                                result.filterMatch.push 0
                        else
                            result.filterMatch.push 0
                    return
                return
            @.results.forEach (result) ->
                if result.filterMatch.indexOf(0) < 0
                    result.el.classList.add 'info-library__card--matching-filter'
        return
    
    FilterResultsByTag: (tagText) ->
        @.RemoveFromFilters 'tag'
        if tagText && tagText.length > 1
            @.AddToFilters 'tag', tagText
        @.FilterResults()
        return
    
    FilterResultsReset: ->
        @.results.forEach (result) ->
            result.el.classList.remove 'info-library__card--matching-filter'
            return
        return

    GetData: ->
        if @.apiMethod == 'GET' || @.apiMethod == 'POST'
            self = @
            try
                if @.apiMethod == 'POST'
                    body = {
                        amount: @.amount
                        mediatypes: @.apiMediatypes
                        offset: @.shownElements
                    }
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                answer = JSON.parse request.responseText
                                self.results.push ...answer.results
                                self.totalResults = parseInt answer.total, 10
                            catch error
                                console.log "Fehler beim Versuch die Info-Bibliothek-Datenquelle zu verarbeiten"
                                self.AppendResults()
                                return
                        else
                            console.log "Die Anfrage der Info-Bibliothek-Datenquelle lieferte ein leeres Ergebnis"
                        self.AppendResults()
                    , ->
                        self.AppendResults()
                        console.log "Bei der Anfrage an die Info-Bibliothek-Datenquelle ist leider ein Fehler aufgetreten"
                        return
                    , if self.apiMethod == 'POST' then JSON.stringify(body) else {}
            catch error
                console.log "Fehler beim Versuch die Info-Bibliothek-Datenquelle zu ermitteln"
                self.AppendResults()
        else
            try
                if window[@.api]
                    @.results = window[@.api]
                else
                    console.log "Fehler beim Versuch die Info-Bibliothek-Datenquelle zu ermitteln"
                @.AppendResults()
            catch error
                console.log "Fehler beim Versuch die Info-Bibliothek-Datenquelle zu verarbeiten"
                @.AppendResults()
        return
    
    GetResultYear: (result) ->
        if result.publishDate
            date = new Date(result.publishDate)
            if isNaN(date)
                date = new Date()
        else
            date = new Date()
        return date.getFullYear()

    InitEvents: ->
        self = @
        @.$toggleFiltersButton.addEventListener 'click', (e) ->
            e.preventDefault()
            self.$el.classList.toggle 'info-library--filters-hidden'
            return
        @.$toggleFiltersButtonMobile.addEventListener 'click', (e) ->
            e.preventDefault()
            self.$el.classList.toggle 'info-library--filters-hidden'
            return
        @.$loadMoreButton.addEventListener 'click', (e) ->
            e.preventDefault()
            self.LoadMore()
            return
        if @.$sortSelect
            @.$sortSelect.addEventListener 'change', (e) ->
                self.sortBy = self.$sortSelect.value.split(',')
                self.SortResults self.sortBy[0], self.sortBy[1]
                self.SortCards()
                return
        if @.$searchbarInputEl
            @.$searchbarInputEl.addEventListener 'input', (e) ->
                if self.loaded
                    self.FilterResultsByTag e.target.value.trim()
                return
        return
    
    InitFilterEvents: ->
        self = @
        return
    
    LoadMore: ->
        self = @
        if !@.$loadMoreButton.disabled
            if @.resultsLoadedAtOnce
                count = 1
                hiddenCards = @.$resultsEl.querySelectorAll '.info-library__card:not(.info-library__card--shown)'
                for infoCardEl in hiddenCards
                    if count > self.amount
                        break
                    else
                        self.shownElements++
                        infoCardEl.classList.add 'info-library__card--shown'
                    count++
                if @.$resultsEl.querySelectorAll('.info-library__card--shown').length >= @.results.length
                    @.$loadMoreButton.disabled = true
            else
                self.GetData()
        return
    
    ReCreateFilters: ->
        @.ResetFilters()
        @.$el.querySelector '.info-library__media-sort-row'
            .innerHTML = ""
        @.$el.querySelector '.info-library__target-sort-row'
            .innerHTML = ""
        @.$el.querySelector '.info-library__topic-sort-row'
            .innerHTML = ""
        @.$el.querySelector '.info-library__year-sort-row'
            .innerHTML = ""
        @.CreateFilter()
        return

    RemoveFromFilters: (filterKey) ->
        filterIndex = @.filters.map((e) -> return e.filterKey).indexOf(filterKey)
        if filterIndex >= 0
            @.filters.splice filterIndex, 1
        if @.filters.length < 1
            @.$el.classList.remove 'info-library--filter-active'
        return
    
    ResetFilters: ->
        @.FilterResultsReset()
        @.filters = []
        @.$el.classList.remove 'info-library--filter-active'
        return
    
    SetLoaded: ->
        @.$el.classList.add 'info-library--loaded'
        @.loaded = true
        return
    
    SortCards: ->
        self = @
        count = 1
        for result in @.results
            result.el.classList.remove 'info-library__card--shown'
            result.el.style.order = count
            if count <= self.shownElements
                result.el.classList.add 'info-library__card--shown'
            count++
        return

    SortResults: (property, direction) ->
        @.results.sort (a,b) ->
            if a[property]
                if direction == 'asc'
                    return if a[property].toLowerCase() >= b[property].toLowerCase() then 1 else -1
                else
                    return if a[property].toLowerCase() <= b[property].toLowerCase() then 1 else -1
        return

BindInfoLibraries = ->
    document.querySelectorAll '.info-library:not(.info-library--bound)'
        .forEach (el) ->
            new InfoLibrary el
            return
    return

window.addEventListener 'bind-components', BindInfoLibraries